/**
 * Shared reCAPTCHA helpers, kept in a dependency-free module so both the provider
 * (index.jsx) and the disclosure component can import it without a circular import.
 */

/** Site preferences can arrive as real booleans or "true"/"false" strings. */
export const isRecaptchaEnabledValue = (value) => value === true || value === 'true';
